/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "../../../../components/common/Modal/Modal";
import Typography from "../../../../components/common/new/Typography/Typography";
import { tableStyles } from "../../../Announcement/ViewAnnouncement/ViewAnnouncement.Style";
import Table from "../../../../components/common/new/Table/Table";
import { VOTING_TABLE_COL } from "../../../../contants/table/appointment";
import { style } from "../style";
import Loader from "../../../../components/common/Loader/Loader";

const getRows = ({ votingData }) => {
  if (!votingData?.data || votingData?.data?.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }
  return votingData?.data?.map((voting) => {
    // console.log("fetch Voting", voting?.voters?.committeeType);

    return (
      <TableRow style={tableStyles.tableRow}>
        <TableCell
          style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}
        >
          {voting?.voterMember?.memberId || "-"}
        </TableCell>
        <TableCell style={style.Cell}>
          {voting?.voterMember?.fullName || "-"}
        </TableCell>
        <TableCell style={style.Cell}>
          {voting?.voterMember?.divisionName || "-"}
        </TableCell>
        <TableCell style={{ ...style.Cell, textAlign: "center" }}>
          {voting?.voterStructureLevel || "-"}
        </TableCell>
        <TableCell style={{ ...style.Cell, textAlign: "center" }}>
          {voting?.didCommitteeMeet === true
            ? "YES"
            : voting?.didCommitteeMeet === false
            ? "NO"
            : "-"}
        </TableCell>
        <TableCell style={{ ...style.Cell, textAlign: "center" }}>
          {voting?.didYouParticipate === true
            ? "YES"
            : voting?.didYouParticipate === false
            ? "NO"
            : "-"}
        </TableCell>
        <TableCell style={{ ...style.Cell, textAlign: "center" }}>
          {voting?.doYouApproveAppointment === true
            ? "YES"
            : voting?.doYouApproveAppointment === false
            ? "NO"
            : "-"}
        </TableCell>
        <TableCell style={{ ...style.Cell }}>
          <Box style={style.status}>{voting?.status || "-"}</Box>
        </TableCell>
        <TableCell style={{ ...style.Cell, textAlign: "center" }}>
          <Box style={style.flexC}>
            <Box style={{ ...style.ActionBtnContainer }}>
              {voting?.doYouApproveAppointmentRemark || "NA"}
            </Box>
          </Box>
        </TableCell>
      </TableRow>
    );
  });
};

function ARCVotingModal({ open, onClose, votingData, isVotingLoading }) {
  const columns = VOTING_TABLE_COL;

  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{
        maxHeight: "95vh",
        maxWidth: "95vw",
        height: "auto",
        borderRadius: "14px",
        background: "#FFF",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        style={{
          paddingBottom: "5px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "1rem",
          flexShrink: 0,
        }}
      >
        <Typography
          style={{
            color: "#8C8C8C",
            fontSize: "20px",
            fontWeight: "500",
          }}
        >
          ARC Approving Status
        </Typography>
        <IconButton>
          <CloseIcon onClick={onClose} />
        </IconButton>
      </Box>

      <Box
        style={{
          flex: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        <div style={{ width: "100%", minWidth: "max-content" }}>
          <Table scrollable columns={columns} rows={getRows({ votingData })} />
        </div>
      </Box>

      {isVotingLoading && <Loader />}
    </Modal>
  );
}

export default ARCVotingModal;
